// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"454":"e2c7ef90","790":"11f61413"}[chunkId] + ".chunk.js";
};